import { MuiThemeComponentsType } from '../types';

export default (): MuiThemeComponentsType['MuiTooltip'] => ({
  styleOverrides: {
    tooltip: {
      fontSize: '14px',
    },
  },
});
